import constants from 'search-interface/shared/constants';
import ngResource from 'angular-resource';

import SolrSearch from './SolrSearch';
import SolrSearchSecure from './SolrSearchSecure';
import SendStats from './SendStats';

export default angular.module('searchEngineFrontend.searchInterface.shared.models', [
  ngResource,
  constants.name
])
  .service('SolrSearch', SolrSearch)
  .service('SolrSearchSecure', SolrSearchSecure)
  .service('SendStats', SendStats);



// WEBPACK FOOTER //
// ./src/search-interface/shared/models/index.js